/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import VueQuillEditor from 'vue-quill-editor';
import VueRouter from 'vue-router';
import VeeValidate from 'vee-validate';
import VueTimeago from 'vue-timeago';
import Paginate from 'vuejs-paginate';
import VueLazyload from 'vue-lazyload';
import NavBar from '@tagboard/tgb-navbar';

import {
  Inputitems,
  Select,
  Input,
  Field,
  Config as OrugaConfig,
} from '@oruga-ui/oruga';

import store from './store/producer';
import AppComponent from './producer/App.vue';
import ColorPickerComponent from './producer/colorpicker/ColorPicker.vue';
import DropdownComponent from './shared/dropdown/Dropdown.vue';
import InputTagComponent from './shared/input-tag/InputTag.vue';
import ProductionComponent from './producer/routes/production/Production.vue';
import ErrorComponent from './producer/routes/404/404.vue';
import ProducerDashboard from './producer/manage-productions/ProducerDashboard.vue';
import ThemesComponent from './producer/routes/themes/Themes.vue';
import SmartPanelsComponent from './producer/routes/panels/SmartPanels.vue';
import GraphicsComponent from './producer/routes/graphics/Graphics.vue';
import TemplatesListComponent from './producer/routes/graphic-templates/GraphicTemplates.vue';
import SavedGraphicsComponent from './producer/routes/saved-graphics/SavedGraphics.vue';
import TagboardsListComponent from './producer/routes/tagboards/TagboardList.vue';
import PostsListComponent from './producer/routes/posts/PostsList.vue';

import SocketIO from './plugins/socket-io';
import Toasts from './plugins/toasts';

import '../sass/producer.scss';

window.jQuery = require('jquery');

window.$ = window.jQuery;

require('bootstrap');

const Sentry = require('@tagboard/lib-sentry-vue');

require('./utils/filters'); // Referenced in child components

const LaunchDarkly = require('@tagboard/launchdarkly');

// Expose this.$ld plugin
Vue.use(LaunchDarkly.vuePlugin({
  userApi: process.env.USER_API,
  clientId: process.env.LAUNCH_DARKLY_CLIENT_ID,
}));

Vue.use(VueRouter);
Vue.use(VeeValidate, {
  events: 'change|blur|input',
});

Vue.use(VueQuillEditor);
Vue.use(Inputitems);
Vue.use(Select);
Vue.use(Input);
Vue.use(Field);
Vue.use(OrugaConfig, {
  inputitems: {
    override: true,
    confirmKeys: [',', 'Tab', 'Enter', ' '],
    closable: true,
  },
  select: {
    iconPack: 'fa',
    iconRight: 'chevron-down',
    useHtml5Validation: true,
  },
  input: {
    useHtml5Validation: true,
  },
  iconPack: 'fas',
});

Vue.component('tgb-navbar', NavBar);
Vue.component('input-tag', InputTagComponent);
Vue.component('colorpicker', ColorPickerComponent);
Vue.component('paginate', Paginate);
Vue.component('dropdown', DropdownComponent);

// Replicate old school VueSocketIO plugin by registering all event listeners found in store actions.
Vue.use(SocketIO, { store });

// Setup global toast methods
Vue.use(Toasts);

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en',
});

Vue.use(VueLazyload);

const routes = [
  {
    path: '/',
    component: AppComponent,
    children: [
      {
        path: '',
        redirect: { name: 'productions', params: { tab: 'all' } },
      },
      {
        path: 'productions/:tab',
        component: ProducerDashboard,
        name: 'productions',
        props: (route) => ({ tab: route.params.tab || 'all' }),
      },
      {
        path: '404',
        component: ErrorComponent,
        name: '404',
      },
      {
        path: ':production_id',
        component: ProductionComponent,
        name: 'production',
        children: [
          {
            path: 'tagboards',
            component: TagboardsListComponent,
            name: 'tagboards',
          },
          {
            path: 'tagboards/:tagboard_id',
            component: PostsListComponent,
            name: 'posts',
          },
          {
            path: 'themes',
            component: ThemesComponent,
            name: 'themes',
          },
          {
            path: 'panels',
            component: SmartPanelsComponent,
            name: 'smartpanels',
          },
          {
            path: 'graphics',
            component: GraphicsComponent,

            children: [
              {
                path: '',
                component: TemplatesListComponent,
                name: 'graphics',
              },
              {
                path: 'saved',
                component: SavedGraphicsComponent,
                name: 'saved-graphics',
              },
            ],
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

try {
  // TODO: lib-sentry shouldn't throw for missing dsn, just ignore
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    env: process.env.NODE_ENV,
    release: process.env.COMMIT_HASH,
    tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE,
    Vue,
    router,
  });

  window.Sentry = Sentry.client;
} catch (err) {
  /* noop */
}

window.vm = new Vue({
  store,
  router,
}).$mount('#app');

window.addEventListener('message', (e) => {
  if (typeof e.data === 'string' && e.data.indexOf('tgbAssetManagerSelectedAsset') === 0) {
    const asset = JSON.parse(e.data.split('|')[1]);
    window.assetmanfn(asset);
  }
}, false);
